import { render } from "./AnnotationForm.vue?vue&type=template&id=5808d5af"
import script from "./AnnotationForm.vue?vue&type=script&lang=js"
export * from "./AnnotationForm.vue?vue&type=script&lang=js"

import "./AnnotationForm.vue?vue&type=style&index=0&id=5808d5af&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__